import React from 'react'
import About from './components/About'
import Contact from './components/Contact'
import Experience from './components/Experience'
import Footer from './components/Footer'
import Header from './components/Header/Header'
import Nav from './components/Nav/Nav'
import Portfolio from './components/Portfolio'
import Services from './components/Services'
import Testimonials from './components/Testimonials'


function App() {
  return (
    <>
   <Header/>
   <Nav />
   <About/>
 <Experience/>
 <Services/>
 <Portfolio/>
 <Testimonials/>
 <Contact/>
 <Footer/>
    
    </>
  )
}

export default App